//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'
var moment = require('moment-timezone')
import { parseNumber as globalizeParseNumber } from 'globalize'

//#endregion

//#region DevExpress Imports

import DevExpress from 'devextreme'
import DataSource from 'devextreme/data/data_source'
import ArrayStore from 'devextreme/data/array_store'

//#endregion

import { i18n } from '../i18n/common.i18n'

//#region Model Imports

import { Enums } from '../../../models/common/enums'
import { OpDataType } from '../../../models/core'
import { MeasureCollection } from '../../../models/custom/measure-collection'

import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { ColumnModel, MeasurementsRequestModel, MeasurementModel, SchemaModel, GridRequestReferenceModel } from '../../api/api.models'

//#endregion

//#region Helper Imports

import { CommonHelper, DataType } from '../../../helpers/common-helper'
import { EventsNames } from '../../../helpers/events-names'
import { OperatorLayoutSettings } from '../../../helpers/operator-layout-settings'
import { Permissions } from '../../../helpers/permissions'
import { RequestManager } from '../../../helpers/request-manager'
import { TemplateHelper, ConfigHelper, LocalizationHelper, ConvertHelper, ToastHelper, KeyType, Dictionary } from '../../../helpers'
import { DataProviderRequest, DataProviderRequestError } from '../../../data-provider'

//#endregion

//#region Servie Imports

import { DataTypeFormatService, DataTypeFormatter } from '../../../services/data-type'
import { UserSessionService } from '../../../services/user-session'
import { MeasurementsService } from './measurements.service'

//#endregion

import { SelectPopoverMultySelectionSource } from '../select-popover/select-popover.directive'
import { DatePickerBridge, CustomDatePeriod } from '../date-picker/date-picker.directive'
import { GridOptions, GridTypes } from '../grid/grid.controller'
import { KPIController } from '../../kpi/kpi.controller'
import { MeasurementsChartBridge } from './chart/chart.directive.controller'
import { IMRBaseControlDirectiveController } from '../base'


enum MeasurementsSelectedFilter {
    Locations = 1,
    Devices = 2,
    Meters = 3
}

export interface MeasurementsBridge {
    id: number
    referenceType?: Enums.ReferenceType
    latestDataMethodName: string
    dataMethodName: string
    requestProperty: string
    locations?: any[]
    devices?: any[]
    meters?: any[]
    groups?: any[]
    aggregationPeriods?: any[]

    data?: () => MeasurementModel[]
    dataCallback?: (data: MeasurementModel[]) => void
    chartBridgeCallback?: (chartBridge: MeasurementsChartBridge) => void

    showMeasurements?: boolean
    allowColumnReordering?: boolean

    chartOptionsPermissions: any[],
    chartDataTypeOptionsPermissions: any[],

    hideChartOptions?: boolean,
    hideDataTypePanel?: boolean
}

export interface MeasurementDataType {
    id: number
    dataTypeId: number
    name: string
    unitType: number
    unitName: string
    isThresholdType?: boolean
    type: number
    chartType?: any
}

interface MeasurementsScope extends ng.IScope {
    preferencesButtonOptions: DevExpress.ui.dxButtonOptions
    refreshButtonOptions: DevExpress.ui.dxButtonOptions
    settingsListRefreshButtonOptions: DevExpress.ui.dxButtonOptions
    exitRefreshButtonOptions: DevExpress.ui.dxButtonOptions
    settingsListExitButtonOptions: DevExpress.ui.dxButtonOptions
    positioningButtonOptions: DevExpress.ui.dxButtonOptions
    exportGridButtonOptions: DevExpress.ui.dxButtonOptions
    settingsListButtonOptions: DevExpress.ui.dxButtonOptions
    loadingIndicatorOptions: DevExpress.ui.dxLoadIndicatorOptions
    settingsListOptions: DevExpress.ui.dxListOptions
    settingsListPopoverOptions: DevExpress.ui.dxPopoverOptions
    datesPopupOptions: DevExpress.ui.dxPopupOptions
    gridTypePopoverOptions: DevExpress.ui.dxPopoverOptions
    gridTypeListOptions: DevExpress.ui.dxListOptions
    positioningPopoverOptions: DevExpress.ui.dxPopoverOptions
    positioningListOptions: DevExpress.ui.dxListOptions
    selectFilterOptions: DevExpress.ui.dxSelectBoxOptions | any
    toolbarOptions: DevExpress.ui.dxToolbarOptions

    //gridster
    isFullScreenGrid: boolean
    isFullScreenChart: boolean
    gridsterOpts: any
    gridsterGridOpts: any
    gridsterChartOpts: any

    filter: MeasurementsSelectedFilter

    datePickerBridge: DatePickerBridge
    selectedPeriod: CustomDatePeriod
    selectedDevices: any[]
    selectedMeters: any[]
    selectedGroups: any[]

    selectedAggregationPeriod: any
    selectedGroupsKPI: any
    selectedMetersKPI: any
    details: boolean
    aggregationPeriodOptions: DevExpress.ui.dxSelectBoxOptions
    detailsOptions: DevExpress.ui.dxCheckBoxOptions
    isKpi: boolean
    locationOptions: any
    meterOptions: any
    locationDataGridOptions: SelectPopoverMultySelectionSource
    meterDataGridOptions: SelectPopoverMultySelectionSource
    onKpiLocationsSelected: (data: any[], message: string) => void
    onKpiMetersSelected: (data: any[], message: string) => void

    chartBridge: MeasurementsChartBridge

    source: MeasurementsBridge

    positioningPopoverVisible: boolean
    gridTypePopoverVisible: boolean
    isButtonsPanelVisible: boolean
    isSettingsListPopoverVisible: boolean
    datesPopoverVisible: boolean
    isRefreshing: boolean
    isGridInCommon: boolean
    //typeTags: any

    gridOptions: GridOptions

    showMeasurementsChart: boolean
    gridBoxValue: any
    dataTypesOptionsPermission: boolean

    //dataTypeFilter
    selectedDataTypesSource: SelectPopoverMultySelectionSource
    onDataTypeFilterSelected: (data: any[]) => void
    onFilterSelected: (data: any[], message: string) => void
    isSelectPopoverLoading: boolean

    isFilterLoading: boolean
    deviceSelectedOptions: SelectPopoverMultySelectionSource
    meterSelectedOptions: SelectPopoverMultySelectionSource
    groupSelectedOptions: SelectPopoverMultySelectionSource
}

export class MeasurementsController extends IMRBaseControlDirectiveController {
    gridId: number

    private static POSITIONS = {
        left: "ChartOnTheLeft",
        right: "ChartOnTheRight",
        top: "ChartOnTheTop",
        bottom: "ChartOnTheBottom",
        fullScreenChart: "FullScreenChart",
        fullScreenGrid: "FullScreenGrid"
    }

    private static IS_FULLSCREEN_GRID = 'IS_FULLSCREEN_GRID'
    private static IS_FULLSCREEN_CHART = 'IS_FULLSCREEN_CHART'
    private static CHART_POSITION = 'CHART_POSITION'

    private GRID_TYPES = {
        IN_COLUMNS: { template: CommonHelper.getTemplateforListRow(i18n('Grid', 'DataTypeColumns'), 'context-menu-row'), id: "data-type-columns" },
        IN_ROWS: { template: CommonHelper.getTemplateforListRow(i18n('Grid', 'DataTypeRows'), 'context-menu-row'), id: "data-type-rows" },
        FIX_COLUMNS: { template: CommonHelper.getTemplateforListRow(i18n('Grid', 'ColumnFixing'), 'context-menu-row', '', 'FORMAT_INCREASE'), id: "column-auto-width" }
    }

    private data: MeasurementModel[]
    private dataTypeFields: ColumnModel[]

    private gridDeferred = $.Deferred<DevExpress.ui.dxDataGrid>()

    private gridColumnsFromTypes = [
        {
            dataField: "date",
            caption: i18n("Common", "Date"),
            dataType: "date",
            sortOrder: 'desc',
            customizeText: (options) => {
                return moment(options.value).format(this.$scope.isKpi ? window['simax'].getDateFormat('DATE_FORMAT_MOMENTJS') : window['simax'].getDateFormat('DATE_TIME_FORMAT_MOMENTJS'))
            },
            editorOptions: {
                displayFormat: window['simax'].getDateFormat('DATE_FORMAT_DX')
            },
            visibleIndex: 0,
            width: 125
        }, {
            dataField: "dataTypeName",
            caption: i18n("Common", "DataType"),
            dataType: "string",
            visibleIndex: 4
        }, {
            dataField: "unit",
            caption: i18n("Common", "Unit"),
            dataType: "string",
            calculateDisplayValue: rowData => {
                var index = this.selectedTypes.map(type => type.id).indexOf(rowData.dataType)
                return (index > -1 ? this.selectedTypes[index].unitName : "")
            },
            alignment: 'left',
            visibleIndex: 6,
            width: 100
        }, {
            dataField: "valueText",
            caption: i18n("Common", "Value"),
            dataType: "string",
            alignment: 'right',
            visibleIndex: 5,
            cellTemplate: (container: JQuery, options) => {
                if (options.data.typeId == CommonHelper.boolean) {
                    var additionalClass = ''
                    var val: boolean = false
                    container.addClass('dx-editor-cell').addClass('measurements-checkbox-in-grid-cell')
                    if (options.data.value) {
                        additionalClass = ' dx-checkbox-checked '
                        val = true
                    } else if (options.data.value == null) {
                        additionalClass = ' dx-checkbox-indeterminate '
                        val = null
                    }
                    var template = $('<div class="dx-datagrid-checkbox-size dx-widget dx-state-readonly' + additionalClass + 'dx-checkbox" aria-readonly="true" role="checkbox" aria-checked="' + val + '"><input type="hidden" value="' + val + '" /><div class="dx-checkbox-container"><span class="dx-checkbox-icon"></span></div></div>')
                    template.appendTo(container)
                } else if (options.data.typeId == CommonHelper.real || options.data.typeId == CommonHelper.integer || options.data.typeId == CommonHelper.decimal) {
                    var value = ''
                    if (options.data.value != null) {
                        value = options.data.value
                        value = this.dataTypeFormatter.formatDisplayValue(+value, {
                            idDataType: options.data.dataType,
                            idDataTypeClass: options.data.typeId
                        })
                    }
                    container.html(value)
                } else if (options.data.typeId == CommonHelper.string) {
                    container.html(options.value)
                } else if (options.data.typeId == Enums.DataTypeClass.Datetime) {
                    var value = ''
                    if (options.data.value) {
                        value = this.dataTypeFormatter.formatDisplayValue(+value, {
                            idDataType: options.data.dataType,
                            idDataTypeClass: Enums.DataTypeClass.Datetime
                        })
                    }
                    container.html(value)
                } else if (options.data.typeId == Enums.DataTypeClass.Date) {
                    var value = ''
                    if (options.data.value) {
                        value = this.dataTypeFormatter.formatDisplayValue(+value, {
                            idDataType: options.data.dataType,
                            idDataTypeClass: Enums.DataTypeClass.Date
                        })
                    }
                    container.html(value)
                } else {
                    value = options.data.value
                    container.html(value)
                }
            }
        }
    ]

    private dataTypesChartStorageName: string = 'defaultChartDataTypes'
    private settings = {
        itemsPosition: { template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ItemsPosition), ConfigHelper.Icon.SIZE, this.userSession) },
        gridLayout: { template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Preferences), ConfigHelper.Icon.REORDER, this.userSession) },
        dates: { template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.DateRange), ConfigHelper.Icon.DATE_RANGE, this.userSession) },
        refresh: { template: '<div><div class="settings-refresh-button" ng-hide="isRefreshing" dx-button="settingsListRefreshButtonOptions"></div><div class="settings-refresh-button settings-exit-button" ng-show="isRefreshing" dx-button="settingsListExitButtonOptions"></div></div>' },
        export: { template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Export), ConfigHelper.Icon.EXPORT, this.userSession) }
    }
    private gridTypePopover: DevExpress.ui.dxPopover
    private positioningPopover: DevExpress.ui.dxPopover
    private loadLatest: boolean

    private selectedTypes: MeasurementDataType[]
    private selectedPeriodName: string

    private buttonsBarWidth: number = null
    private loadDataTimeout
    private lastSelectedTypes: MeasurementDataType[] = []
    private selectedGridType: any

    private lastSelectedFilter: number = 0
    private lastSelectedIds: any[] = []
    private disableTypesOnChange: boolean = false

    private requestState: any = {}

    private wasFiltered: boolean = false
    private thresholdTypes: MeasurementDataType[]
    private endDateBoxArray: any[]
    private startDateBoxArray: any[]

    private activeModule = () => {
        switch (this.$scope.filter) {
            default:
            case MeasurementsSelectedFilter.Locations:
                return "location"
            case MeasurementsSelectedFilter.Devices:
                return "device"
            case MeasurementsSelectedFilter.Meters:
                return "meter"
        }
    }

    private columnFixButtonElement: any
    private dataTypeFormatter: DataTypeFormatter

    constructor(
        private $scope: MeasurementsScope,
        $element: ng.IRootElementService,
        private $q: ng.IQService,
        private $timeout: ng.ITimeoutService,
        $compile: ng.ICompileService,
        private api: Api,
        private localDictionary: LocalDictionaryFactory,
        private dataTypeFormatService: DataTypeFormatService,
        private measurementsService: MeasurementsService,
        private userSession: UserSessionService
    ) {
        super()

        var positionList = [MeasurementsController.POSITIONS.left, MeasurementsController.POSITIONS.right, MeasurementsController.POSITIONS.top, MeasurementsController.POSITIONS.bottom, MeasurementsController.POSITIONS.fullScreenChart, MeasurementsController.POSITIONS.fullScreenGrid]

        var gridTypesItems = [this.GRID_TYPES.IN_COLUMNS, this.GRID_TYPES.IN_ROWS, this.GRID_TYPES.FIX_COLUMNS]
        this.selectedGridType = OperatorLayoutSettings.getSetting(OperatorLayoutSettings.MeasurementsGridType, this.GRID_TYPES.IN_ROWS.id)

        $scope.source.showMeasurements = false

        $scope.dataTypesOptionsPermission = true
        $scope.isFullScreenGrid = OperatorLayoutSettings.getSetting(MeasurementsController.IS_FULLSCREEN_GRID, false)
        $scope.isFullScreenChart = OperatorLayoutSettings.getSetting(MeasurementsController.IS_FULLSCREEN_CHART, false)
        $scope.datesPopoverVisible = false
        $scope.positioningPopoverVisible = false
        $scope.isRefreshing = false

        $scope.gridsterOpts = {
            rowHeight: '100%',
            columns: 4, // the width of the grid, in columns
            pushing: true,
            swapping: true,
            floating: true,
            outerMargin: false, // whether margins apply to outer edges of the grid
            isMobile: false, // stacks the grid items if true
            mobileBreakPoint: 200, // if the screen is not wider that this, remove the grid layout and stack the items
            mobileModeEnabled: true, // whether or not to toggle mobile mode when screen width is less than mobileBreakPoint
            minColumns: 1, // the minimum columns the grid must have
            minRows: 1, // the minimum height of the grid, in rows
            maxRows: 4,
            defaultSizeX: 2, // the default width of a gridster item, if not specifed
            defaultSizeY: 1, // the default height of a gridster item, if not specified
            minSizeX: 1, // minimum column width of an item
            maxSizeX: 4, // maximum column width of an item
            minSizeY: 1, // minumum row height of an item
            maxSizeY: 4, // maximum row height of an item
            resizable: {
                enabled: false
            },
            draggable: {
                enabled: false
            }
        }
        this.setGridsterChartOnLeft()

        $scope.loadingIndicatorOptions = {
            width: 40,
            height: 40
        }

        $scope.datePickerBridge = {
            fromDate: null,
            toDate: null,
            callback: (selectedPeriod) => {
                if ($scope.datesPopoverVisible == false) {
                    this.loadMeasurementsFromPeriod(selectedPeriod)
                }
                else {
                    $scope.selectedPeriod = selectedPeriod
                }
            },
            customPeriods: [
                {
                    id: "latest",
                    title: i18n('Common', 'Latest')
                }
            ],
            isSmallScreen: false
        }

        MeasurementsController.getMeasurementsTypeSelectBoxDataSource($q, $scope, localDictionary, $scope.source.groups, $scope.source.devices, $scope.source.meters, $scope.source.requestProperty == "locationIds" || $scope.isKpi, $scope.source.requestProperty == "deviceIds", $scope.source.requestProperty == "meterIds" || $scope.isKpi).then(filterOptions => {
            $scope.filter = OperatorLayoutSettings.getSetting(CommonHelper.filterSelection + $scope.source.requestProperty, filterOptions[0].type)

            if ($scope.isKpi) {
                filterOptions[0].name = i18n('Common', 'Locations');
            } else {
                $scope.isKpi = false;
            }

            $scope.details = OperatorLayoutSettings.getSetting('KPI_DETAILS', false)

            $scope.detailsOptions = {
                value: false,
                bindingOptions: {
                    value: "details"
                },
                onValueChanged: function (e) {
                    $scope.details = e.value;
                    OperatorLayoutSettings.setSetting('KPI_DETAILS', $scope.details)
                }
            }

            if ($scope.isKpi) {
                $scope.onKpiLocationsSelected = (data: any[], message: string) => {
                    $scope.selectedGroupsKPI = data.map(g => g['id'])
                    $scope.selectedGroups = data
                    $scope.locationDataGridOptions.selectedIds = $scope.selectedGroupsKPI
                    $scope.source.groups = data
                    OperatorLayoutSettings.setSetting(KPIController.KPI_SELECTED_LOCATIONS, $scope.selectedGroupsKPI)
                    this.loadMeasurements(true, 1000)
                }

                $scope.onKpiMetersSelected = (data: any[], message: string) => {
                    $scope.selectedMetersKPI = data.map(m => m['id'])
                    $scope.selectedMeters = data
                    $scope.meterDataGridOptions.selectedIds = $scope.selectedMetersKPI
                    $scope.source.meters = data
                    OperatorLayoutSettings.setSetting(KPIController.KPI_SELECTED_METERS, $scope.selectedMetersKPI)
                    this.loadMeasurements(true, 1000)
                }

                this.localDictionary.getLocationColumns().then(columns => {
                    this.localDictionary.getActiveViewColumnsForReferenceType(CommonHelper.IdLocation).then(columnsForWhere => {
                        $scope.locationDataGridOptions = {
                            myltySelection: true,
                            dictionaryMethod: 'getLocationColumns',
                            staticSource: [],
                            selectedIds: OperatorLayoutSettings.getSetting(KPIController.KPI_SELECTED_LOCATIONS, []),
                            visible: true,
                            referenceTypeId: CommonHelper.IdLocation,
                            isKPI: true,
                            saveName: "kpiLocationDataGrid"
                        }
                    })
                });

                this.localDictionary.getMeterColumns().then(columns => {
                    this.localDictionary.getActiveViewColumnsForReferenceType(CommonHelper.IdMeter).then(columnsForWhere => {
                        $scope.meterDataGridOptions = {
                            myltySelection: true,
                            dictionaryMethod: 'getMeterColumns',
                            staticSource: [],
                            selectedIds: OperatorLayoutSettings.getSetting(KPIController.KPI_SELECTED_METERS, []),
                            visible: true,
                            referenceTypeId: CommonHelper.IdMeter,
                            isKPI: true,
                            saveName: "kpiMeterDataGridOptions"
                        }
                    })
                })
            }

            if ($scope.isKpi && $scope.source.aggregationPeriods) {
                let aps = $scope.source.aggregationPeriods.map(ap => {
                    return {
                        id: ap,
                        name: i18n("Common", ap)
                    }
                });
                let defaultAP;

                if (aps.length > 3) {
                    $scope.selectedAggregationPeriod = aps[2];
                    defaultAP = OperatorLayoutSettings.getSetting('KPI_AGREGATION_PERIOD', aps[2]).id;
                }

                $scope.aggregationPeriodOptions = {
                    dataSource: aps,
                    valueExpr: 'id',
                    displayExpr: 'name',
                    noDataText: i18n("Common", "NoData"),
                    placeholder: i18n("Common", "SelectPlaceholder"),
                    hint: i18n("Common", "AggregationPeriod"),
                    value: defaultAP,
                    onInitialized: e => {
                        let selectBox: DevExpress.ui.dxSelectBox = e.component;
                        if ($scope.selectedAggregationPeriod && $scope.selectedAggregationPeriod.length > 0) {
                            $scope.selectedAggregationPeriod = aps[0];
                        }
                        $timeout(() => {
                            selectBox.option('onSelectionChanged', e => {
                                $scope.selectedAggregationPeriod = e.selectedItem;
                                OperatorLayoutSettings.setSetting('KPI_AGREGATION_PERIOD', $scope.selectedAggregationPeriod)
                                this.refresh();
                            })
                        })
                    }
                };
            }

            if (filterOptions.map(filter => filter.type).indexOf($scope.filter) == -1 && filterOptions[0])
                $scope.filter = filterOptions[0].type

            this.updateChartStorage($scope.filter)
            $scope.selectFilterOptions = {
                dataSource: filterOptions,
                valueExpr: 'type',
                displayExpr: 'name',
                itemTemplate: (itemData, itemIndex: number, itemElement) => {
                    var div = $('<div></div>')
                    var name = $('<div></div>')
                    name.append(itemData.name)

                    var icon = $('<div class="drop-down-button-icon" style="width: 20px;">' + TemplateHelper.getIcon(itemData.icon, userSession) + '</div>')
                    icon = $compile(icon)($scope)
                    div.append(name)
                    div.append(icon)
                    div.addClass('drop-down-item')
                    itemElement.append(div)
                },
                dropDownButtonTemplate: () => {
                    var selectedItem = _.find(filterOptions, x => x.type == $scope.filter)
                    var ddb = '<div class="drop-down-button-icon">' + TemplateHelper.getIcon(selectedItem.icon, userSession) + '</div>'
                    return ddb
                },
                onInitialized: e => {
                    var selectBox: DevExpress.ui.dxSelectBox = e.component
                    $timeout(() => {
                        selectBox.option('onSelectionChanged', e => {
                            $scope.isSelectPopoverLoading = true
                            $scope.filter = e.selectedItem.type
                            this.updateChartStorage($scope.filter)
                            OperatorLayoutSettings.setSetting(CommonHelper.filterSelection + $scope.source.requestProperty, $scope.filter)
                            this.loadMeasurements(true, 1000)
                        })
                    })
                },
                onSelectionChanged: selectedItems => {
                    $scope.isFilterLoading = true
                    $timeout(() => {
                        $scope.isFilterLoading = false
                    })
                },
            }
        })

        $scope.gridOptions = {
            type: GridTypes.NO_SEARCH_BAR_PAGINATED_SMALL,
            columns: [],
            allowColumnReordering: $scope.source.allowColumnReordering != null ? $scope.source.allowColumnReordering : true,
            onInitialized: e => {
                this.gridDeferred.resolve(e.component)
                this.gridId = e.tableId
                $timeout(() => { e.component.refresh() }, 300)
            },
            name: this.activeModule() + "MeasurementsGrid" + this.selectedGridType,
            buttonsOptions: {
                enabled: false
            },
            paging: {
                pageSize: 50,
                enabled: true
            },
            addCustomFilters: true
        }

        $scope.chartBridge = {
            data: void 0,
            selectedTypes: [],
            filterId: $scope.filter,
            tickInterval: { hours: 2 },
            dataTypesChartStorageName: this.dataTypesChartStorageName,
            updateChart: false,
            clearChart: false,
            thresholdTypes: this.thresholdTypes,
            chartOptionsPermissions: $scope.source.chartOptionsPermissions,
            chartDataTypeOptionsPermissions: $scope.source.chartDataTypeOptionsPermissions,
            hideChartOptions: $scope.source.hideChartOptions,
            hideDataTypePanel: $scope.source.hideDataTypePanel,
            useAggregation: this.measurementsService.getGLobalConfiguration().useAggregation
        }
        if ($scope.source.chartBridgeCallback) $scope.source.chartBridgeCallback($scope.chartBridge)

        //tags
        $scope.isSelectPopoverLoading = true
        $scope.selectedDataTypesSource = {
            myltySelection: true,
            dictionaryMethod: 'getMeasurementsDataTypesFilterColumns',
            staticSource: [],
            selectedIds: [],
            visible: true,
            saveName: "selectedDataTypesSource"
        }

        $scope.onDataTypeFilterSelected = (data) => {
            if (this.$scope.source.hideDataTypePanel != null) {
                this.setDataTypeFilterOptions(data, this.$scope.source.hideDataTypePanel)
            } else {
                Permissions.hasPermissions(this.$scope.source.chartDataTypeOptionsPermissions).then(dtypesPermission => {
                    this.setDataTypeFilterOptions(data, dtypesPermission)
                })
            }
        }

        $scope.onFilterSelected = (data, message) => {
            if (!data) data = []
            switch ($scope.filter) {
                case MeasurementsSelectedFilter.Locations:
                    this.$scope.groupSelectedOptions.selectedIds = data.map(d => { return d.id })
                    $scope.selectedGroups = data
                    break
                case MeasurementsSelectedFilter.Devices:
                    this.$scope.deviceSelectedOptions.selectedIds = data.map(d => { return d.id })
                    $scope.selectedDevices = data
                    break
                case MeasurementsSelectedFilter.Meters:
                    this.$scope.meterSelectedOptions.selectedIds = data.map(d => { return d.id })
                    $scope.selectedMeters = data
                    break
            }
            this.loadMeasurements()
        }

        //close tagbox dropdown width fix
        $scope.$on(EventsNames.WINDOW_RESIZED, () => {
            //$scope.typeTags.close()
        })

        $scope.meterSelectedOptions = {
            myltySelection: true,
            dictionaryMethod: 'getMeasurementsDataTypesFilterColumns',
            staticSource: [],
            selectedIds: [],
            visible: true,
            saveName: 'meterSelectedData'
        }

        $scope.groupSelectedOptions = {
            myltySelection: true,
            dictionaryMethod: 'getMeasurementsDataTypesFilterColumns',
            staticSource: [],
            selectedIds: [],
            visible: true,
            saveName: 'groupSelectedData'
        }

        $scope.gridTypePopoverVisible = false

        $scope.refreshButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.REFRESH, userSession),
            hint: i18n("Common", "Refresh"),
            onClick: () => { this.refresh() }
        }

        $scope.settingsListRefreshButtonOptions = {
            template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Refresh), ConfigHelper.Icon.REFRESH, userSession),
            hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Refresh),
            onClick: () => { this.refresh() }
        }

        $scope.settingsListExitButtonOptions = {
            template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.CancelLoading), ConfigHelper.Icon.CLOSE, userSession),
            hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Close),
            onClick: () => {
                $scope.isSettingsListPopoverVisible = false
                this.exitRefresh()
            }
        }

        $scope.exportGridButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.EXPORT, userSession),
            hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Export),
            onClick: () => {
                this.gridDeferred.then(grid => {
                    let request = this.getRequest()

                    this.measurementsService.exportMeasurements({
                        gridColumns: grid.option('columns'),
                        dateFrom: request.dateFrom,
                        dateTo: request.dateTo,
                        dataTypes: _.map(request.columns, (column: ColumnModel) => column.id),
                        viewStyle: request.measurementViewStyle,
                        deviceIds: request.deviceIds,
                        locationIds: request.locationIds,
                        meterIds: request.meterIds,
                    })
                })
            }
        }

        $scope.exitRefreshButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.CLOSE, userSession),
            hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.CancelLoading),
            onClick: () => { this.exitRefresh() }
        }

        $scope.preferencesButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.REORDER, userSession),
            hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Preferences),
            onClick: () => {
                this.gridTypePopover.option("target", '#grid-button-' + $scope.$id)
                this.gridTypePopover.option("position", "bottom")
                this.toggleGridTypePopover()
            }
        }

        $scope.positioningButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.SIZE, userSession),
            hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ChangePosition),
            visible: !$scope.isGridInCommon,
            onClick: () => {
                this.positioningPopover.option("target", '#position-button-' + $scope.$id)
                this.positioningPopover.option("position", "bottom")
                $scope.positioningPopoverVisible = !$scope.positioningPopoverVisible
            }
        }

        $scope.settingsListButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.SHOW_OPTIONS, userSession),
            hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowOptions),
            onClick: () => {
                $scope.isSettingsListPopoverVisible = !$scope.isSettingsListPopoverVisible
            }
        }

        $scope.settingsListPopoverOptions = {
            target: '#popoverSettingsListButton',
            width: 200,
            bindingOptions: {
                visible: 'isSettingsListPopoverVisible'
            },
            onShowing: e => {
                e.component.content().css({
                    'padding': 0,
                    'text-align': 'center',
                    'border-radius': 'inherit'
                })
            },
            onHidden: () => {
                $scope.isSettingsListPopoverVisible = false
            }
        }


        var settingsList = [
            this.settings.gridLayout, this.settings.dates, this.settings.refresh, this.settings.export
        ]
        if (!$scope.isGridInCommon) {
            settingsList.unshift(this.settings.itemsPosition)
        }

        $scope.settingsListOptions = {
            items: settingsList,
            onItemClick: e => {
                this.executeAction(settingsList[e.itemIndex])
            },
            onContentReady: () => {
                var refreshButton = angular.element('.settings-refresh-button')
                refreshButton.parent().parent().css({
                    padding: '0px 0px'
                })
                var exitRefreshButton = angular.element('.settings-exit-button')
                exitRefreshButton.parent().parent().css({
                    padding: '0px 0px'
                })
                angular.element('.refresh-button-row').children().first().css({
                    "margin-bottom": "5px"
                })
                angular.element('.exit-button-row').children().first().css({
                    "margin-bottom": "5px"
                })
            }
        }

        $scope.datesPopupOptions = {
            maxWidth: 250,
            maxHeight: 300,
            title: i18n('Grid', 'DateRange'),
            bindingOptions: {
                visible: 'datesPopoverVisible'
            },
            onHidden: () => {
                $scope.datesPopoverVisible = false
                $scope.isSettingsListPopoverVisible = false
            }
        }

        $scope.gridTypePopoverOptions = {
            target: '#grid-button-' + $scope.$id,
            width: 200,
            bindingOptions: {
                visible: 'gridTypePopoverVisible'
            },
            onInitialized: e => {
                this.gridTypePopover = e.component
            },
            onShowing: e => {
                e.component.content().css({
                    'padding': 0,
                    'text-align': 'center',
                    'border-radius': 'inherit'
                })
            }
        }

        $scope.positioningPopoverOptions = {
            target: '#position-button-' + $scope.$id,
            width: 160,
            bindingOptions: {
                visible: 'positioningPopoverVisible'
            },
            onInitialized: e => {
                this.positioningPopover = e.component
            },
            onShowing: e => {
                e.component.content().css({
                    'padding': 0,
                    'text-align': 'center',
                    'border-radius': 'inherit'
                })
            }
        }

        $scope.positioningListOptions = {
            items: positionList.map(key => i18n("Grid", key)),
            onItemClick: e => {
                $scope.isSettingsListPopoverVisible = false
                $scope.positioningPopoverVisible = false
                this.setPosition(positionList[e.itemIndex])
            }
        }

        $scope.gridTypeListOptions = {
            items: gridTypesItems,
            onItemClick: e => {
                $scope.isSettingsListPopoverVisible = false
                $scope.gridTypePopoverVisible = false

                if (e.itemData.id != this.GRID_TYPES.FIX_COLUMNS.id) {
                    this.selectedGridType = e.itemData.id
                    e.component.option("items").forEach(item => { item.disabled = false })
                    e.itemData.disabled = true
                }

                OperatorLayoutSettings.setSetting(OperatorLayoutSettings.MeasurementsGridType, this.selectedGridType)
                //gridColumns
                $timeout(() => {
                    switch (e.itemData.id) {
                        case this.GRID_TYPES.IN_ROWS.id: {
                            this.updateGridColumnsDataTypeRows()
                            break
                        }
                        case this.GRID_TYPES.IN_COLUMNS.id: {
                            this.updateGridColumnsDataTypeColumns()
                            break
                        }
                        case this.GRID_TYPES.FIX_COLUMNS.id: {
                            this.gridDeferred.promise().then(grid => {
                                var tableConfig = OperatorLayoutSettings.getSetting('SAVED_TABLE_' + this.$scope.gridOptions.name, null)

                                var columns = []
                                for (var i = 0; i < (<any>grid).columnCount(); i++) {
                                    columns.push((<any>grid).columnOption(i))
                                    columns[i].width = null
                                }

                                grid.option({
                                    columnAutoWidth: !tableConfig.columnAutoWidth,
                                    columns: columns
                                })
                                this.colorFixingButton(this.columnFixButtonElement)
                            })
                            return
                        }
                    }
                    this.loadMeasurements(false)
                })
            },
            onItemRendered: e => {
                if (e.itemData.id == this.selectedGridType)
                    e.itemData.disabled = true
                if (e.itemData.id == this.GRID_TYPES.FIX_COLUMNS.id) {
                    this.columnFixButtonElement = e.itemElement
                    this.colorFixingButton(this.columnFixButtonElement)
                }
            }
        }

        if ($scope.isFullScreenGrid) {
            this.gridToFullScreen()
        }
        else if ($scope.isFullScreenChart) {
            this.chartToFullScreen()
        }
        else {
            this.showBoth()
        }

        $timeout(() => {
            $scope.isButtonsPanelVisible = true
            $scope.$watch(() => {
                if (!$scope.isButtonsPanelVisible) return null
                return $element.find('.measurements-buttons-panel').width()
            }, width => {
                if (width != null) {
                    this.buttonsBarWidth = width + 200 // 200 for filter
                }
            })

            $scope.$watch(() => {
                if (this.buttonsBarWidth == null) return null
                return $element.find('.measurements-controls').width()
            }, (barContainerWidth) => {
                if (barContainerWidth != null) {
                    if (barContainerWidth - this.buttonsBarWidth <= 0) {
                        $scope.isButtonsPanelVisible = false
                        $scope.datePickerBridge.isSmallScreen = true
                    }
                    else {
                        $scope.isSettingsListPopoverVisible = false
                        $scope.isButtonsPanelVisible = true
                        $scope.datePickerBridge.isSmallScreen = false
                        $scope.datesPopoverVisible = false
                    }
                    $scope.gridTypePopoverVisible = false
                    $scope.positioningPopoverVisible = false
                }
            })
        }, 500)

        $scope.$watch(() => {
            return angular.element('.gridster-custom-container').innerHeight()
        }, (contentHeight) => {
            $scope.gridsterOpts.rowHeight = (contentHeight) / 4
            var windowWidth = angular.element(window).width()

            if ($scope.gridsterOpts.rowHeight < 100 && windowWidth >= 768) $scope.gridsterOpts.rowHeight = 100
            else if (windowWidth < 768) $scope.gridsterOpts.rowHeight = 200
        })

        $scope.$watch(() => {
            return angular.element(window).width()
        }, (windowWidth) => {
            if (windowWidth < 768) $scope.gridsterOpts.isMobile = true
            else $scope.gridsterOpts.isMobile = false
        })

        var groupsDefer = $q.defer<void>()
        var testN = 0, testN2 = 0
        $scope.$watchCollection('source.groups', (result: any[]) => {
            if (!result) result = []
            this.updateTagBox('groupTags', 'groupTagsOptions', 'selectedGroups', result)
            groupsDefer.resolve()
        })

        var devicesDefer = $q.defer<void>()
        $scope.$watchCollection('source.devices', (result: any[]) => {
            if (!result) result = []
            var devices = result.map(device => {
                if (device.id && device.name && device.referenceId)
                    return device
                else
                    return {
                        id: device[CommonHelper.idField],
                        name: device[CommonHelper.nameField],
                        referenceId: device.referenceId
                    }
            })
            this.updateTagBox('deviceTags', 'deviceTagsOptions', 'selectedDevices', devices)
            devicesDefer.resolve()
        })

        var metersDefer = $q.defer<void>()
        $scope.$watchCollection('source.meters', (result: any[]) => {
            if (!result) result = []
            var meters = result.map(meter => {
                if (meter.id && meter.name && meter.referenceId)
                    return meter
                else
                    return {
                        id: meter[CommonHelper.idField],
                        name: meter[CommonHelper.nameField],
                        referenceId: meter.referenceId
                    }
            })
            this.updateTagBox('meterTags', 'meterTagsOptions', 'selectedMeters', meters)
            metersDefer.resolve()
        })

        $q.all([groupsDefer.promise, devicesDefer.promise, metersDefer.promise]).then(() => {
            $scope.$watch('source.id', (sourceId: number) => {
                var data = $scope.source.data ? $scope.source.data() : null
                if (data) {
                    this.loadTypes().then(() => {
                        this.data = data

                        var actualData = this.data
                        if (this.selectedGridType == this.GRID_TYPES.IN_COLUMNS.id) {
                            actualData = this.changeDataToRows(this.data)
                        }
                        else {
                            actualData = this.addDataTypeNameToData(actualData)
                        }

                        this.updateGrid(actualData)
                        this.updateChart(this.data).then(() => {
                            this.$timeout(() => {
                                $scope.source.showMeasurements = true
                                $timeout(() => {
                                    $scope.chartBridge.updateChart = true
                                    $scope.showMeasurementsChart = true
                                    this.gridDeferred.then(grid => { grid.refresh() })
                                }, 500)

                            }, 0)
                        })
                    })
                } else {
                    this.loadMeasurements()
                }
            })
        })

        $scope.$on(EventsNames.STOP_MEASUREMENTS_LOADING, () => {
            this.cancel()
        })

        $scope.$on(EventsNames.SCHEMA_CHANGED, (...args) => {
            var schema: SchemaModel = args[1]
            if (this.data) {
                var needUpdate = false
                var newData = []
                var columnName, listName
                if (this.$scope.filter == MeasurementsSelectedFilter.Locations && schema.referenceType == CommonHelper.IdLocation) {
                    this.data.forEach(d => {
                        if (d.idLocation == schema.idObject)
                            newData.push(d)
                    })
                    needUpdate = true
                    columnName = 'Location'
                    listName = 'selectedGroups'
                } else if (this.$scope.filter == MeasurementsSelectedFilter.Devices && schema.referenceType == CommonHelper.IdDevice) {
                    this.data.forEach(d => {
                        if (d.serialNbr == schema.idObject)
                            newData.push(d)
                    })
                    needUpdate = true
                    columnName = 'Device'
                    listName = 'selectedDevices'
                } else if (this.$scope.filter == MeasurementsSelectedFilter.Meters && schema.referenceType == CommonHelper.IdMeter) {
                    this.data.forEach(d => {
                        if (d.idMeter == schema.idObject)
                            newData.push(d)
                    })
                    needUpdate = true
                    columnName = 'Meter'
                    listName = 'selectedMeters'
                }

                if (needUpdate) {
                    var actualData = newData
                    if (this.selectedGridType == this.GRID_TYPES.IN_COLUMNS.id) {
                        actualData = this.changeDataToRows(newData)
                    }

                    var objectName = schema.idObject
                    this.$scope[listName].some(e => {
                        if (e.id == schema.idObject) {
                            objectName = e.name
                            return true
                        }
                        return false
                    })

                    this.updateGrid(actualData, [{
                        columnName: i18n('Common', columnName),
                        condition: '= "' + objectName + '"',
                        clearFilter: () => {
                            var actualData = this.data
                            if (this.selectedGridType == this.GRID_TYPES.IN_COLUMNS.id) {
                                actualData = this.changeDataToRows(this.data)
                            }
                            else {
                                actualData = this.addDataTypeNameToData(actualData)
                            }
                            this.updateGrid(actualData)
                            this.updateChart(this.data)
                        }
                    }])
                    this.updateChart(newData)
                }
            }
        })

        $scope.$on('updateMeasurements', () => {
            this.updateData(false)
        })

        $scope.toolbarOptions = {
            items: [
                {
                    location: 'center',
                    widget: 'dxButton',
                    options: {
                        text: i18n('Common', 'Cancel'),
                        onClick: () => {
                            this.$scope.datesPopoverVisible = false
                            this.$scope.selectedPeriod = null
                        }
                    }
                },
                {
                    location: 'center',
                    widget: 'dxButton',
                    options: {
                        text: i18n('Common', 'Ok'),
                        onClick: () => {
                            if (this.$scope.selectedPeriod != null)
                                this.loadMeasurementsFromPeriod(this.$scope.selectedPeriod)
                            this.$scope.datesPopoverVisible = false
                            this.$scope.selectedPeriod = null
                        }
                    }
                }
            ]
        }
    }

    static checkMeasurementsDataTypes($q: ng.IQService, localDictionary: LocalDictionaryFactory, objects: any[], isNeeded: boolean, method: (n: number) => ng.IPromise<ColumnModel[]>) {
        if (isNeeded) {
            var defer = $q.defer<boolean>()
            defer.resolve(true)
            return defer.promise
        }
        else if (objects && objects.length > 0) {
            var promises: ng.IPromise<number>[] = []
            var referenceIds = []
            objects.forEach(obj => {
                if (referenceIds.indexOf(obj.referenceId) == -1) {
                    promises.push(method.call(localDictionary, obj.referenceId).then(fields => fields.length))
                    referenceIds.push(obj.referenceId)
                }
            })
            return $q.all(promises).then(lengths => {
                var dataTypesExist = false
                lengths.forEach(length => {
                    if (length > 0) dataTypesExist = true
                })
                return dataTypesExist
            })
        }
    }

    static getMeasurementsTypeSelectBoxDataSource($q: ng.IQService, $scope: ng.IScope, localDictionary: LocalDictionaryFactory, locations: any[], devices: any[], meters: any[], needLocations = false, needDevices = false, needMeters = false) {
        var allPromises: ng.IPromise<boolean>[] = []
        if (!$scope['isKpi']) needLocations = false, needDevices = false, needMeters = false //show item in filterSelect box only if there is any DataType
        allPromises.push(this.checkMeasurementsDataTypes($q, localDictionary, locations, needLocations, localDictionary.getMeasurementsForLocationFields))
        allPromises.push(this.checkMeasurementsDataTypes($q, localDictionary, devices, needDevices, localDictionary.getMeasurementsForDeviceFields))
        allPromises.push(this.checkMeasurementsDataTypes($q, localDictionary, meters, needMeters, localDictionary.getMeasurementsForMeterFields))

        return $q.all(allPromises).then(result => {
            var dataSource = []

            if (result[0]) {
                dataSource.push({
                    name: i18n('Common', 'CurrentLocation'),
                    type: 1,
                    icon: ConfigHelper.Icon.LOCATIONS
                })
            }

            if (result[1]) {
                dataSource.push({
                    name: i18n('Common', 'Devices'),
                    type: 2,
                    icon: ConfigHelper.Icon.DEVICES
                })
            }

            if (result[2]) {
                dataSource.push({
                    name: i18n('Common', 'Meters'),
                    type: 3,
                    icon: ConfigHelper.Icon.METERS
                })
            }

            if (dataSource.length == 0) {
                if ((locations && locations.length == 0) && (devices && devices.length == 0) && (meters && meters.length == 0)) {
                    dataSource.push({
                        name: i18n('Common', 'CurrentLocation'),
                        type: 1,
                        icon: ConfigHelper.Icon.LOCATIONS
                    })
                    dataSource.push({
                        name: i18n('Common', 'Devices'),
                        type: 2,
                        icon: ConfigHelper.Icon.DEVICES
                    })
                    dataSource.push({
                        name: i18n('Common', 'Meters'),
                        type: 3,
                        icon: ConfigHelper.Icon.METERS
                    })
                } else {
                    if ((locations && locations.length > 0) || needLocations)
                        dataSource.push({
                            name: i18n('Common', 'CurrentLocation'),
                            type: 1,
                            icon: ConfigHelper.Icon.LOCATIONS
                        })
                    if ((devices && devices.length > 0) || needDevices)
                        dataSource.push({
                            name: i18n('Common', 'Devices'),
                            type: 2,
                            icon: ConfigHelper.Icon.DEVICES
                        })
                    if ((meters && meters.length > 0) || needMeters)
                        dataSource.push({
                            name: i18n('Common', 'Meters'),
                            type: 3,
                            icon: ConfigHelper.Icon.METERS
                        })
                }
            }

            return dataSource
        })
    }

    private addThresholdTypes() {
        this.thresholdTypes.forEach(thrType => {
            if (!this.selectedTypes.some(t => t.id == thrType.id))
                this.selectedTypes.push(thrType)
        })
    }

    private getLocations = (request: GridRequestReferenceModel) => {
        this.$scope.$root.$broadcast('disableLoadingIndicator')
        return this.api.kpi.getLocations(request).then(result => {
            this.$scope.$root.$broadcast('enableLoadingIndicator')
            return result
        })
    }

    private getMeters = (request: GridRequestReferenceModel) => {
        this.$scope.$root.$broadcast('disableLoadingIndicator')
        return this.api.kpi.getMeters(request).then(result => {
            this.$scope.$root.$broadcast('enableLoadingIndicator')
            return result
        })
    }

    private cancel(): boolean {
        var result = this.requestState.request && !this.requestState.request.$resolved
        if (this.requestState && result) {
            RequestManager.cancelRequest(this.requestState)
            this.requestState.cancelled = true
        }
        return result
    }

    private updateChartStorage(filter: MeasurementsSelectedFilter) {
        switch (filter) {
            default:
            case MeasurementsSelectedFilter.Locations:
                this.dataTypesChartStorageName = 'locationChartDataTypes'
                break;
            case MeasurementsSelectedFilter.Devices:
                this.dataTypesChartStorageName = 'deviceChartDataTypes'
                break;
            case MeasurementsSelectedFilter.Meters:
                this.dataTypesChartStorageName = 'meterChartDataTypes'
                break;
        }
        if (this.$scope.isKpi) {
            this.dataTypesChartStorageName = 'KPI' + this.dataTypesChartStorageName;
        }
    }

    private addDataTypeNameToData(actualData: MeasurementModel[]) {
        const dataTypeDict = Dictionary.createFromArray(this.dataTypeFields, KeyType.Number, (item: ColumnModel) => {
            return item.id;
        });

        _.forEach(actualData, value => {
            const columnModel: ColumnModel = dataTypeDict.tryGetValue(value.dataType);

            if (columnModel != null)
                value['dataTypeName'] = columnModel.caption
            else
                value['dataTypeName'] = value.dataType
        })

        return actualData
    }

    private changeDataToRows(data: any[]) {
        let keyParamName = ''
        let secondaryParamName = ''
        let thirdParamName = 'locationString'

        switch (this.$scope.filter) {
            case MeasurementsSelectedFilter.Locations:
            case MeasurementsSelectedFilter.Devices:
                keyParamName = 'deviceString'
                secondaryParamName = 'meterString'
                break
            case MeasurementsSelectedFilter.Meters:
                keyParamName = 'meterString'
                secondaryParamName = 'deviceString'
                break
        }

        const newDataDict = new Dictionary<Record<string, any>>(null, KeyType.String);

        data.forEach(d => {
            const dataKey: string = `${d[keyParamName]} ${d[secondaryParamName]} ${d[thirdParamName]} ${d.date.getTime()}`;

            if (newDataDict.containsKey(dataKey)) {
                const newDataItem = newDataDict.tryGetValue(dataKey);

                if (newDataItem != null) {
                    newDataItem[d.dataType.toString()] = d.value
                }
            } else {
                const newObj: Record<string, any> = {};

                newObj[keyParamName] = d[keyParamName];
                newObj[secondaryParamName] = d[secondaryParamName];
                newObj[thirdParamName] = d[thirdParamName];
                newObj.date = d.date;
                newObj[d.dataType.toString()] = d.value;
                newObj.dataType = d.dataType;

                newDataDict.addOrUpdate(dataKey, newObj);
            }
        })

        return newDataDict.values() as any[];
    }

    private updateData(reload: boolean = true, timeout: number = 0) {
        var defer = this.$q.defer<void>()
        this.$scope.source.showMeasurements = !reload
        this.$scope.showMeasurementsChart = false
        if (this.loadDataTimeout) this.$timeout.cancel(this.loadDataTimeout)
        this.loadDataTimeout = this.$timeout(() => {
            this.loadTypes().then(() => {
                if (reload) {
                    this.lastSelectedTypes = this.selectedTypes
                    if (!this.lastSelectedTypes) {
                        this.$scope.source.showMeasurements = true
                        this.$timeout(() => {
                            this.$scope.showMeasurementsChart = true
                        }, 500)
                        this.$scope.chartBridge.updateChart = true
                        defer.resolve()
                        return
                    }

                    var dictionaries = {}

                    this.lastSelectedTypes.forEach(t => {
                        dictionaries[t.id] = t.unitName
                    })

                    this.$scope.isRefreshing = true
                    this.getData().then(data => {
                        if (!data) data = []
                        data.forEach(d => {
                            var unit = dictionaries[d.dataType]
                            if (unit)
                                d['unit'] = unit
                        })
                        this.data = data
                        if (this.$scope.source.dataCallback) this.$scope.source.dataCallback(this.data)

                        var actualData = data
                        if (this.selectedGridType == this.GRID_TYPES.IN_COLUMNS.id) {
                            actualData = this.changeDataToRows(data)
                        }
                        else {
                            actualData = this.addDataTypeNameToData(actualData)
                        }

                        this.updateGrid(actualData)
                        this.updateChart(this.data).then(() => {
                            this.$timeout(() => {
                                this.$scope.source.showMeasurements = true
                                this.$timeout(() => {
                                    this.$scope.chartBridge.updateChart = true
                                    this.$scope.showMeasurementsChart = true
                                }, 500)
                                defer.resolve()
                            }, 0)
                        })
                    }).catch(e => {
                        this.updateChart([]).then(() => {
                            this.$timeout(() => {
                                this.$scope.source.showMeasurements = true
                                this.$timeout(() => {
                                    this.$scope.chartBridge.updateChart = true
                                    this.$scope.showMeasurementsChart = true
                                }, 500)
                                defer.resolve()
                            }, 0)
                        })
                        defer.reject()
                    }).finally(() => {
                        this.$scope.isRefreshing = false
                    })
                } else if (this.data) {

                    var removedTypes: number[] = this.lastSelectedTypes.filter(lastSelectedType => {
                        return this.selectedTypes.every(selectedType => !(selectedType.id == lastSelectedType.id))
                    }).map(type => type.id)

                    this.data = this.data.filter(d => {
                        return removedTypes.every(removedType => !(removedType == d.dataType))
                    })

                    if (this.selectedGridType == this.GRID_TYPES.IN_COLUMNS.id) {
                        var data = this.changeDataToRows(this.data)
                        this.updateGrid(data)

                        this.$scope.chartBridge.updateChart = false
                        this.$scope.chartBridge.selectedTypes = this.$scope.chartBridge.selectedTypes.filter(type => this.selectedTypes.some(sType => sType.id == type['dataTypeId'] || sType.id == type.id))
                    } else if (this.selectedGridType == this.GRID_TYPES.IN_ROWS.id) {
                        if (this.$scope.source.dataCallback) this.$scope.source.dataCallback(this.data)

                        this.data = this.addDataTypeNameToData(this.data)

                        this.updateGrid(this.data)
                        if (removedTypes.length > 0)
                            this.updateChart(this.data)
                    }

                    this.lastSelectedTypes = this.selectedTypes
                    this.$timeout(() => {
                        this.$scope.source.showMeasurements = true
                        this.$timeout(() => {
                            this.$scope.showMeasurementsChart = true
                            this.$scope.chartBridge.updateChart = true
                        }, 500)
                    }, 0)
                    defer.resolve()
                }
            })
        }, timeout)
        return defer.promise
    }

    private updateGrid(data, additionalFilters = null) {
        var filteredData = []
        data.forEach(element => {
            if (!this.thresholdTypes.some(thresholdType => { return thresholdType.id == element.dataType })) {
                element.idMeterText = element['meterString'] || element.idMeter
                element.serialNbrText = element['deviceString'] || element.serialNbr
                element.idLocationText = element['locationString'] || element.idLocation

                if (!this.$scope.isKpi)
                    this.$scope.selectedMeters.some(e => {
                        if (e.id == element.idMeter) {
                            element.idMeterText = e.name
                            return true
                        }
                        return false
                    })

                filteredData.push(element)
            }
        })
        this.gridDeferred.promise().then(grid => {
            this.$scope.gridOptions.additionalFilters = additionalFilters
            var dataSource = new DataSource(<any>{
                store: new ArrayStore({ data: filteredData }),
                onLoadingChanged: e => {
                    if (!this.wasFiltered) {
                        if (this.$scope.isKpi) {
                            var gridOptions: any = grid.option()
                            gridOptions.columns.forEach(col => {
                                if (col.dataField == 'idMeterText' || col.dataField == 'idLocation') {
                                    col.visible = this.$scope.details
                                }
                            })
                            grid.option(gridOptions)
                        }

                        var filter = grid.getCombinedFilter()
                        if (filter) {
                            var value = filter[2]
                            if (typeof (value) == 'string') {

                                if (globalizeParseNumber(value)) {
                                    value = globalizeParseNumber(value)
                                    var filterOpeartion = filter[1]
                                    var columnIndex = filter.columnIndex

                                    var gridOptions: any = grid.option()
                                    gridOptions.columns[columnIndex].filterOperations = [filterOpeartion]
                                    gridOptions.columns[columnIndex].filterValue = [value]

                                    grid.option(gridOptions)
                                }
                            }
                        }
                        this.wasFiltered = true
                    }
                }
            })
            var fields: string[] = this.dataTypeFields.map(item => { if (item.type == CommonHelper.real) return item.name })
            grid.option('onEditorPreparing', function (e) {
                if (e.parentType == "filterRow" && (fields.indexOf(e.dataField) > -1 ? true : false)) {
                    e.editorOptions.mode = "number";
                }
            })
            dataSource.pageSize(100)
            grid.option('dataSource', dataSource)
            grid.refresh()
        })
    }

    private updateChart(data) {
        this.$scope.showMeasurementsChart = false
        var deferred = this.$q.defer();
        var period
        let labelFormat: any = { label: 'yyyy' };

        if (this.$scope.isKpi && this.$scope.selectedAggregationPeriod) {
            switch (this.$scope.selectedAggregationPeriod.id) {
                case "day":
                    period = { days: 1 };
                    labelFormat = { format: 'shortDate' }
                    break
                case "week":
                    period = { days: 7 }
                    labelFormat = {
                        format: (value => {
                            return moment(value).format('Y W ') + i18n("Common", "Week");
                        })
                    }
                    break
                case "month":
                    period = { months: 1 }
                    labelFormat = { format: 'monthAndYear' }
                    break
                case "quarter":
                    period = { quarters: 1 }
                    labelFormat = { format: 'quarterAndYear' }
                    break
                case "semester":
                    period = { months: 6 }
                    labelFormat = {
                        format: (value => {
                            return moment(value).format('Y ') + i18n("Common", "Semester") + (moment(value).format('Q') > 2 ? " 2" : " 1");
                        })
                    }
                    break
                case "year":
                    period = { years: 1 }
                    labelFormat = { format: 'year' }
                    break
                case "whole":
                    period = { years: 1 }
                    labelFormat = {
                        format: (value => {
                            return i18n("Common", "Whole");
                        })
                    }
                    break
            }
        } else {
            switch (this.selectedPeriodName) {
                default:
                case "latest":
                case "day":
                    period = { hours: 2 }
                    break
                case "week":
                    period = { days: 1 }
                    break
                case "month":
                    period = { weeks: 1 }
                    break
                case "year":
                    period = { months: 1 }
                    break
            }
        }

        var idFieldName: string, entityName: string
        switch (this.$scope.filter) {
            default:
            case MeasurementsSelectedFilter.Locations:
                idFieldName = 'idLocation'
                entityName = 'groups'
                break;
            case MeasurementsSelectedFilter.Devices:
                idFieldName = 'serialNbr'
                entityName = 'devices'
                break;
            case MeasurementsSelectedFilter.Meters:
                idFieldName = 'idMeter'
                entityName = 'meters'
                break;
        }

        if (this.$scope.isKpi) {
            idFieldName = 'idMeter';
            entityName = 'meters';
        }

        var tooltips = this.$scope.source[entityName].map(obj => {
            return {
                id: [obj.id],
                name: obj.name
            }
        })

        var chartData = MeasurementsController.getChartData(data, this.selectedTypes, idFieldName, tooltips)
        this.$scope.chartBridge = null
        this.$timeout(() => {
            this.$scope.chartBridge = {
                data: chartData.data,
                selectedTypes: chartData.types,
                thresholdTypes: this.thresholdTypes,
                filterId: this.$scope.filter,
                tickInterval: period,
                labelFormat: labelFormat,
                dataTypesChartStorageName: this.dataTypesChartStorageName,
                updateChart: false,
                clearChart: false,
                isKPI: this.$scope.isKpi,
                chartOptionsPermissions: this.$scope.source.chartOptionsPermissions,
                chartDataTypeOptionsPermissions: this.$scope.source.chartDataTypeOptionsPermissions,
                hideChartOptions: this.$scope.source.hideChartOptions,
                hideDataTypePanel: this.$scope.source.hideDataTypePanel,
                useAggregation: this.measurementsService.getGLobalConfiguration().useAggregation
            }
            if (this.$scope.source.chartBridgeCallback) this.$scope.source.chartBridgeCallback(this.$scope.chartBridge)

            deferred.resolve()
        })

        this.$timeout(() => {
            this.$scope.showMeasurementsChart = true
        })

        return deferred.promise
    }

    private loadTypes() {
        var defer = this.$q.defer()
        var ids = []
        var method: (referenceValue: number) => ng.IPromise<ColumnModel[]>
        var storageName = ""
        switch (this.$scope.filter) {
            default:
            case MeasurementsSelectedFilter.Locations:
                method = this.localDictionary.getMeasurementsForLocationFields
                storageName = "locationDataTypes"
                ids = this.$scope.selectedGroups.map(object => object.referenceId)
                break;
            case MeasurementsSelectedFilter.Devices:
                method = this.localDictionary.getMeasurementsForDeviceFields
                storageName = "deviceDataTypes"
                ids = this.$scope.selectedDevices.map(object => object.referenceId)
                break;
            case MeasurementsSelectedFilter.Meters:
                method = this.localDictionary.getMeasurementsForMeterFields
                storageName = "meterDataTypes"
                ids = this.$scope.selectedMeters.map(object => object.referenceId)
                break;
        }

        if (this.$scope.isKpi) {
            method = this.localDictionary.getLPGKPIParams;
            storageName = "KPI" + storageName;
            ids = [1];
        }


        this.dataTypeFormatService
            .getDataTypeFormatter(ids)
            .then((dataTypeFormatter: DataTypeFormatter) => {
                this.dataTypeFormatter = dataTypeFormatter

                var refresh = this.lastSelectedFilter != this.$scope.filter
                if (!refresh) refresh = this.lastSelectedIds.length != ids.length
                if (!refresh) {
                    refresh = !ids.every(id => this.lastSelectedIds.indexOf(id) > -1)
                }
                if (refresh) {
                    this.lastSelectedFilter = this.$scope.filter
                    this.lastSelectedIds = ids

                    this.$q.all(ids.map(id => {
                        return method.call(this.localDictionary, id)
                    })).then((result: ColumnModel[][]) => {
                        var fields: ColumnModel[] = []
                        var addedIds = []
                        result.forEach(df => {
                            df.forEach(f => {
                                if (addedIds.indexOf(f.name) == -1) {
                                    addedIds.push(f.name)
                                    fields.push(f)
                                }
                            })
                        })
                        this.dataTypeFields = fields
                        var types = MeasurementsController.getTypesFromColumns(fields)
                        var savedIds = OperatorLayoutSettings.getSetting(storageName, types.map(type => type.id)).filter(id => {
                            return types.some(t => t.id == id)
                        })

                        this.selectedTypes = types.filter(type => savedIds.some(id => type.id == id))
                        //if (this.selectedTypes.length == 0 )
                        //    this.selectedTypes = types                

                        // sort
                        var selectedTypes = []
                        var allTypesIds = this.selectedTypes.map(type => type.id)
                        savedIds.forEach(id => {
                            var index = allTypesIds.indexOf(id)
                            var selectedType = this.selectedTypes[index]
                            selectedTypes.push(selectedType)
                            this.selectedTypes.splice(index, 1)
                            allTypesIds.splice(index, 1)
                        })
                        if (this.selectedTypes.length > 0)
                            selectedTypes.push(...this.selectedTypes)
                        this.selectedTypes = selectedTypes

                        // add threshold
                        this.localDictionary.getThreshold().then((result: any[]) => {
                            if (this.$scope.source.hideDataTypePanel != null) {
                                this.setThresholds(result, this.$scope.source.hideDataTypePanel, types, savedIds)
                                defer.resolve()
                            } else {
                                Permissions.hasPermissions(this.$scope.source.chartDataTypeOptionsPermissions).then(dtypesPermission => {
                                    this.setThresholds(result, dtypesPermission, types, savedIds)
                                    defer.resolve()
                                })
                            }
                        })
                    })
                } else {
                    defer.resolve()
                }
            })

        return defer.promise
    }

    private updateGridOptions(options: any) {
        var gridTempOptions = this.$scope.gridOptions
        gridTempOptions.columnFixing = options.columnFixing
        gridTempOptions.columns = options.columns
        gridTempOptions.name = this.activeModule() + "MeasurementsGrid" + this.selectedGridType,
            this.gridDeferred = $.Deferred<DevExpress.ui.dxDataGrid>()
        this.$scope.gridOptions = null

        this.$timeout(() => {
            this.$scope.gridOptions = gridTempOptions
            if (this.columnFixButtonElement) this.colorFixingButton(this.columnFixButtonElement)
        }, 500)
    }

    private getAdditionalColumn(dataField: string, dataFieldText: string, caption: string, listName: string) {
        var index = undefined
        if (dataField == 'idLocation') index = 1
        else if (dataField == 'serialNbr') index = 2
        else if (dataField == 'idMeter') index = 3
        return {
            dataField: dataFieldText,
            caption: i18n('Common', caption),
            dataType: 'string',
            visibleIndex: index
        }
    }

    private getAdditionalColumns(columns: any[]) {
        const result: any = []

        if (!this.$scope.isKpi) {
            switch (this.$scope.source.referenceType) {
                case Enums.ReferenceType.IdLocation:
                    result.push(this.getAdditionalColumn('serialNbr', 'serialNbrText', 'Device', 'selectedDevices'))
                    result.push(this.getAdditionalColumn('idMeter', 'idMeterText', 'Meter', 'selectedMeters'))

                    break

                case Enums.ReferenceType.SerialNbr:
                    result.push(this.getAdditionalColumn('idLocation', 'idLocationText', 'Location', 'selectedGroups'))
                    result.push(this.getAdditionalColumn('idMeter', 'idMeterText', 'Meter', 'selectedMeters'))

                    break

                case Enums.ReferenceType.IdMeter:
                    result.push(this.getAdditionalColumn('idLocation', 'idLocationText', 'Location', 'selectedGroups'))
                    result.push(this.getAdditionalColumn('serialNbr', 'serialNbrText', 'Device', 'selectedDevices'))

                    break

                default:
                    switch (this.$scope.filter) {
                        default:
                        case MeasurementsSelectedFilter.Locations:
                            if (this.$scope.selectedGroups && this.$scope.selectedGroups.length > 1) {
                                result.push(this.getAdditionalColumn('idLocation', 'idLocation', 'Location', 'selectedGroups'))
                            }

                            if (this.$scope.source.devices && this.$scope.source.devices.length > 0) {
                                result.push(this.getAdditionalColumn('serialNbr', 'serialNbrText', 'Device', 'selectedDevices'))
                            }

                            if (this.$scope.source.meters && this.$scope.source.meters.length > 0) {
                                result.push(this.getAdditionalColumn('idMeter', 'idMeterText', 'Meter', 'selectedMeters'))
                            }

                            break;

                        case MeasurementsSelectedFilter.Devices:
                            if (this.$scope.source.groups && this.$scope.source.groups.length > 0) {
                                result.push(this.getAdditionalColumn('idLocation', 'idLocation', 'Location', 'selectedGroups'))
                            }

                            if (this.$scope.selectedDevices && this.$scope.selectedDevices.length > 1) {
                                result.push(this.getAdditionalColumn('serialNbr', 'serialNbrText', 'Device', 'selectedDevices'))
                            }

                            if (this.$scope.source.meters && this.$scope.source.meters.length > 0) {
                                result.push(this.getAdditionalColumn('idMeter', 'idMeterText', 'Meter', 'selectedMeters'))
                            }

                            break;

                        case MeasurementsSelectedFilter.Meters:
                            if (this.$scope.source.groups && this.$scope.source.groups.length > 0) {
                                result.push(this.getAdditionalColumn('idLocation', 'idLocation', 'Location', 'selectedGroups'))
                            }

                            if (this.$scope.source.devices && this.$scope.source.devices.length > 0) {
                                result.push(this.getAdditionalColumn('serialNbr', 'serialNbrText', 'Device', 'selectedDevices'))
                            }

                            if (this.$scope.selectedMeters && this.$scope.selectedMeters.length > 1) {
                                result.push(this.getAdditionalColumn('idMeter', 'idMeterText', 'Meter', 'selectedMeters'))
                            }

                            break;
                    }
                    break
            }
        } else {
            if (this.$scope.selectedGroups && this.$scope.selectedGroups.length > 1) {
                result.push(this.getAdditionalColumn('idLocation', 'idLocationText', 'Location', 'selectedGroups'))
            }

            if (this.$scope.source.meters && this.$scope.source.meters.length > 1) {
                result.push(this.getAdditionalColumn('idMeter', 'idMeterText', 'Meter', 'selectedMeters'))
            }
        }

        result.push(...columns)

        return result
    }

    private updateGridColumnsDataTypeRows() {
        var columns = this.getAdditionalColumns(this.gridColumnsFromTypes)

        this.$scope.gridOptions.columns = columns

        this.$scope.$broadcast(EventsNames.UPDATE_GRID_COLUMNS + this.gridId, columns)

        this.updateGridOptions({
            columnFixing: {
                enabled: false
            },
            columns: columns
        })
    }

    private updateGridColumnsDataTypeColumns() {
        var gridColumns = []
        var dateCol = {
            dataField: "date",
            caption: i18n("Common", "Date"),
            dataType: "date",
            sortOrder: 'desc',
            customizeText: (options) => {
                return moment(options.value).format(this.$scope.isKpi ? window['simax'].getDateFormat('DATE_FORMAT_MOMENTJS') : window['simax'].getDateFormat('DATE_TIME_FORMAT_MOMENTJS'))
            },
            editorOptions: {
                displayFormat: window['simax'].getDateFormat('DATE_FORMAT_DX'),
                onInitialized: e => {
                    var startPlaceholder = i18n("Common", "Start")
                    var endPlaceholder = i18n("Common", "End")
                    var lastOnValueChanged = e.component.option('onValueChanged')

                    if (e.component._options.placeholder == startPlaceholder) {
                        CommonHelper.betweenDateFilterMinVal(e, startPlaceholder, this.$timeout, this.endDateBoxArray)
                        this.startDateBoxArray = [e]
                    } else if (e.component._options.placeholder == endPlaceholder) {
                        CommonHelper.betweenDateFilterMaxVal(e, endPlaceholder, this.$timeout, this.startDateBoxArray)
                        this.endDateBoxArray = [e]
                    }
                    e.component.option('onValueChanged', e => {
                        lastOnValueChanged(e)
                        CommonHelper.betweenDateFilterMinVal(e, startPlaceholder, this.$timeout, this.endDateBoxArray)
                        CommonHelper.betweenDateFilterMaxVal(e, endPlaceholder, this.$timeout, this.startDateBoxArray)
                    })
                }
            }
        }
        gridColumns.push(dateCol)
        this.selectedTypes.forEach((type) => {
            if (!type.isThresholdType) {
                var unit = ''
                if (type.unitName != '') unit = ' [' + type.unitName + ']'

                var dataType = 'string'
                var typeId
                if (type.type == CommonHelper.integer || type.type == CommonHelper.real) {
                    dataType = 'number'
                } else if (type.type == CommonHelper.boolean) {
                    dataType = 'boolean'
                } else if (type.type == CommonHelper.datetime || type.type == CommonHelper.date) {
                    dataType = 'date'
                }

                var column: any = {
                    dataField: type.id.toString(),
                    dataType: dataType,
                    caption: type.name + unit,
                    typeId: type.type,
                    customizeText: (options) => {
                        options.typeId = type.type
                        return CommonHelper.cellFormatForDifferentValues(options, type.type, type.id)
                    },
                    alignment: type.type == CommonHelper.boolean ? 'center' : 'right'
                }

                if (type.type == CommonHelper.boolean) {
                    column.cellTemplate = (container: JQuery, options) => {
                        var additionalClass = ''
                        var value: boolean = false
                        container.addClass('dx-editor-cell')
                        if (options.value) {
                            additionalClass = ' dx-checkbox-checked '
                            value = true
                        } else if (options.value == null) {
                            additionalClass = ' dx-checkbox-indeterminate '
                            value = null
                        }
                        var template = $('<div class="dx-datagrid-checkbox-size dx-widget dx-state-readonly' + additionalClass + 'dx-checkbox" aria-readonly="true" role="checkbox" aria-checked="' + value + '"><input type="hidden" value="' + value + '" /><div class="dx-checkbox-container"><span class="dx-checkbox-icon"></span></div></div>')
                        template.appendTo(container)
                    }
                }
                gridColumns.push(column)
            }
        })

        gridColumns = this.getAdditionalColumns(gridColumns)

        this.$scope.gridOptions.columns = gridColumns

        this.$scope.$broadcast(EventsNames.UPDATE_GRID_COLUMNS + this.gridId, gridColumns)

        this.updateGridOptions({
            columnFixing: {
                enabled: true
            },
            columns: gridColumns
        })
    }

    private canRefreshMeasurments(selectedTypes: MeasurementDataType[]) {
        if (selectedTypes.length > this.lastSelectedTypes.length) return true
        return !selectedTypes.every(selectedType => {
            return !this.lastSelectedTypes.every(lastSelectedType => !(selectedType.id == lastSelectedType.id))
        })
    }

    private loadMeasurements(reload: boolean = true, timeout: number = 0) {
        return this.updateData(reload, timeout)
    }

    private loadMeasurementsFromPeriod(selectedPeriod) {
        this.selectedPeriodName = selectedPeriod.id
        this.loadLatest = selectedPeriod.id == "latest"
        this.updateData(true, 1000)
    }

    private refreshGridColumns() {
        if (this.selectedGridType == this.GRID_TYPES.IN_COLUMNS.id) {
            this.updateGridColumnsDataTypeColumns()
        } else {
            this.updateGridColumnsDataTypeRows()
        }
    }

    private getRequest(): MeasurementsRequestModel {
        var req = new MeasurementsRequestModel()
        req.columns = <any>this.selectedTypes
        switch (this.$scope.filter) {
            default:
            case MeasurementsSelectedFilter.Locations:
                req.locationIds = this.$scope.selectedGroups.map(object => +object.id)
                break;
            case MeasurementsSelectedFilter.Devices:
                if (this.$scope.selectedGroups && this.$scope.selectedGroups.length > 0)
                    req.locationIds = this.$scope.selectedGroups.map(object => +object.id)
                req.deviceIds = this.$scope.selectedDevices.map(object => +object.id)
                break;
            case MeasurementsSelectedFilter.Meters:
                if (this.$scope.selectedGroups && this.$scope.selectedGroups.length > 0)
                    req.locationIds = this.$scope.selectedGroups.map(object => +object.id)
                req.meterIds = this.$scope.selectedMeters.map(object => +object.id)
                break;
        }

        var fromDate = this.$scope.datePickerBridge.fromDate
        req.dateFrom = moment(fromDate).toDate()
        req.dateFrom.setHours(0, 0, 0, 0)
        var momentFrom = moment(fromDate)
        req.dateFrom = momentFrom.add(momentFrom.utcOffset(), 'minutes').toDate()

        var toDate = this.$scope.datePickerBridge.toDate
        req.dateTo = moment(toDate).toDate()
        req.dateTo.setHours(23, 59, 59, 999)
        var momentTo = moment(toDate)
        req.dateTo = momentTo.add(momentTo.utcOffset(), 'minutes').toDate()

        switch (this.selectedGridType) {
            case this.GRID_TYPES.IN_COLUMNS.id:
                req.measurementViewStyle = Enums.MeasurementViewStyle.DataInColumns
                break
            case this.GRID_TYPES.IN_ROWS.id:
                req.measurementViewStyle = Enums.MeasurementViewStyle.DataInRows
                break
        }

        if (this.$scope.isKpi && this.$scope.selectedAggregationPeriod) {
            req.aggregationPeriod = this.$scope.selectedAggregationPeriod.id;
            req.isRawData = this.$scope.details;
            switch (this.$scope.filter) {
                default:
                case MeasurementsSelectedFilter.Locations:
                    if (!(req.locationIds.length > 0)) {
                        req.locationIds = this.$scope.source.groups.map(object => object.id);
                    }
                    break;
                case MeasurementsSelectedFilter.Meters:
                    if (!(req.meterIds.length > 0)) {
                        req.meterIds = this.$scope.source.meters.map(object => object.id);
                    }
                    break;
            }
        }
        return req
    }

    private updateTagBox(tagsName: string, tagsNameOptions: string, name: string, data: any[]) {
        var distinct = []
        data.forEach(item => {
            if (!distinct.some(d => { return d.id == item.id })) distinct.push(item)
        })
        data = distinct
        this.$scope[name] = data
        var visible = data.length > 0

        if (tagsNameOptions == 'groupTagsOptions') {
            this.$scope.isFilterLoading = true
            this.$scope.groupSelectedOptions = {
                myltySelection: true,
                dictionaryMethod: 'getMeasurementsDataTypesFilterColumns',
                staticSource: data,
                selectedIds: data.map(d => { return d.id }),
                visible: visible,
                saveName: 'groupSelectedData'
            }
            this.$scope.isFilterLoading = false
        }

        if (tagsNameOptions == 'deviceTagsOptions' && this.$scope.source != null) {
            let serialNbrColumn: ColumnModel[] = []
            this.$scope.isFilterLoading = true

            if (this.$scope.source.referenceType === Enums.ReferenceType.IdLocation) {
                serialNbrColumn = this.getSingleColumnByDataType(Enums.SimaxModuleName.Location, Enums.DataType.HELPER_SERIAL_NBR)
            }

            this.$scope.deviceSelectedOptions = {
                columns: serialNbrColumn,
                myltySelection: true,
                dictionaryMethod: 'getMeasurementsDataTypesFilterColumns',
                staticSource: data,
                selectedIds: data.map(d => { return d.id }),
                visible: visible,
                saveName: 'deviceSelectedData'
            }
            this.$scope.isFilterLoading = false
        }

        if (tagsNameOptions == 'meterTagsOptions') {
            this.$scope.isFilterLoading = true
            this.$scope.meterSelectedOptions = {
                myltySelection: true,
                dictionaryMethod: 'getMeasurementsDataTypesFilterColumns',
                staticSource: data,
                selectedIds: data.map(d => { return d.id }),
                visible: visible,
                saveName: 'meterSelectedData'
            }
            this.$scope.isFilterLoading = false
        }
    }

    private toggleGridTypePopover() {
        this.$scope.gridTypePopoverVisible = !this.$scope.gridTypePopoverVisible
    }

    private refresh() {
        if (this.$scope.isKpi) this.wasFiltered = false
        if (this.$scope.chartBridge) {
            this.$scope.chartBridge.updateChart = false
            this.$scope.chartBridge.data = void 0
        }

        this.loadMeasurements().then(() => {
            this.$scope.isSettingsListPopoverVisible = false
        })
    }

    private exitRefresh() {
        if (this.cancel()) {
            this.$timeout(() => {
                this.gridDeferred.promise().then(grid => {
                    grid.option('dataSource', [])
                    grid.refresh()
                })
                if (this.$scope.chartBridge)
                    this.$scope.chartBridge.clearChart = true
            }, 0)
            this.$timeout(() => {
                this.$scope.source.showMeasurements = true
                this.$timeout(() => {
                    this.$scope.showMeasurementsChart = true
                })
            }, 100)
            this.$scope.isRefreshing = false
        }
    }

    private executeAction(settings) {
        switch (settings) {
            case this.settings.itemsPosition:
                this.positioningPopover.option("target", "#items-position-row")
                this.positioningPopover.option("position", "right")
                this.$scope.positioningPopoverVisible = true
                break
            case this.settings.gridLayout:
                this.gridTypePopover.option("target", "#grid-layout-row")
                this.gridTypePopover.option("position", "right")
                this.$scope.gridTypePopoverVisible = true
                break
            case this.settings.dates:
                this.$scope.datesPopoverVisible = !this.$scope.datesPopoverVisible
                break
            case this.settings.refresh:
                this.refresh()
                break
            case this.settings.export:
                this.$scope.isSettingsListPopoverVisible = false
                this.gridDeferred.promise().then(grid => {
                    grid.exportToExcel(false)
                })
                break
        }
    }

    private setGridsterChartOnLeft(): void {
        this.$scope.gridsterGridOpts = { sizeX: 2, sizeY: 4, row: 0, col: 2 }
        this.$scope.gridsterChartOpts = { sizeX: 2, sizeY: 4, row: 0, col: 0 }
    }

    private setGridsterChartOnRight(): void {
        this.$scope.gridsterGridOpts = { sizeX: 2, sizeY: 4, row: 0, col: 0 }
        this.$scope.gridsterChartOpts = { sizeX: 2, sizeY: 4, row: 0, col: 2 }
    }

    private setGridsterChartOnTop(): void {
        this.$scope.gridsterGridOpts = { sizeX: 4, sizeY: 2, row: 2, col: 0 }
        this.$scope.gridsterChartOpts = { sizeX: 4, sizeY: 2, row: 0, col: 0 }
    }

    private setGridsterChartOnBottom(): void {
        this.$scope.gridsterGridOpts = { sizeX: 4, sizeY: 2, row: 0, col: 0 }
        this.$scope.gridsterChartOpts = { sizeX: 4, sizeY: 2, row: 2, col: 0 }
    }

    private setPosition(position) {
        this.setGridsterChartOnLeft()
        if (position == MeasurementsController.POSITIONS.fullScreenGrid) {
            this.gridToFullScreen()
        } else if (position == MeasurementsController.POSITIONS.fullScreenChart) {
            this.chartToFullScreen()
        } else {
            OperatorLayoutSettings.setSetting(MeasurementsController.CHART_POSITION, position)
            this.$scope.isFullScreenChart = false
            this.$scope.isFullScreenGrid = false
            OperatorLayoutSettings.setSetting(MeasurementsController.IS_FULLSCREEN_GRID, false)
            OperatorLayoutSettings.setSetting(MeasurementsController.IS_FULLSCREEN_CHART, false)
            switch (position) {
                case MeasurementsController.POSITIONS.left: {
                    this.setGridsterChartOnLeft()
                    break
                }
                case MeasurementsController.POSITIONS.right: {
                    this.setGridsterChartOnRight()
                    break
                }
                case MeasurementsController.POSITIONS.top: {
                    this.setGridsterChartOnTop()
                    break
                }
                case MeasurementsController.POSITIONS.bottom: {
                    this.setGridsterChartOnBottom()
                    break
                }
            }
            this.$timeout(() => {
                this.gridDeferred.promise().then(grid => {
                    grid.updateDimensions()
                })
                if (this.$scope.chartBridge)
                    this.$scope.chartBridge.updateChart = true
            }, 200)
        }
    }

    private gridToFullScreen() {
        this.$scope.isFullScreenGrid = true
        this.$scope.isFullScreenChart = false
        OperatorLayoutSettings.setSetting(MeasurementsController.IS_FULLSCREEN_GRID, true)
        OperatorLayoutSettings.setSetting(MeasurementsController.IS_FULLSCREEN_CHART, false)
        this.$scope.gridsterGridOpts = { sizeX: 4, sizeY: 4, row: 0, col: 0 }
        this.$timeout(() => {
            this.gridDeferred.promise().then(grid => {
                grid.updateDimensions()
            })
        }, 0)
    }

    private chartToFullScreen() {
        this.$scope.isFullScreenChart = true
        this.$scope.isFullScreenGrid = false
        OperatorLayoutSettings.setSetting(MeasurementsController.IS_FULLSCREEN_GRID, false)
        OperatorLayoutSettings.setSetting(MeasurementsController.IS_FULLSCREEN_CHART, true)
        this.$scope.gridsterChartOpts = { sizeX: 4, sizeY: 4, row: 0, col: 0 }
        this.$timeout(() => {
            if (this.$scope.chartBridge)
                this.$scope.chartBridge.updateChart = true
        }, 0)
    }

    private showBoth() {
        this.$scope.isFullScreenGrid = false
        this.$scope.isFullScreenChart = false
        OperatorLayoutSettings.setSetting(MeasurementsController.IS_FULLSCREEN_GRID, false)
        OperatorLayoutSettings.setSetting(MeasurementsController.IS_FULLSCREEN_CHART, false)
        var chartPosition = OperatorLayoutSettings.getSetting(MeasurementsController.CHART_POSITION, MeasurementsController.POSITIONS.right)
        this.setPosition(chartPosition)
    }

    private getData(): ng.IPromise<MeasurementModel[]> {
        if (this.cancel()) {
            this.gridDeferred.promise().then(grid => {
                grid.option('dataSource', [])
            })
        }

        var req = this.getRequest()

        if (req.columns.filter(c => !c['isThresholdType']).length == 0) {
            CommonHelper.openInfoPopup(i18n('Popup', 'PleaseSelectDatatype'), 'info')
            const defer: ng.IDeferred<MeasurementModel[]> = this.$q.defer<MeasurementModel[]>()
            defer.resolve([])
            return defer.promise
        }

        if (window['config'].USE_REST_API && !this.$scope.isKpi) {
            const defer: ng.IDeferred<MeasurementModel[]> = this.$q.defer<MeasurementModel[]>()
            var dataProviderRequest: DataProviderRequest<MeasureCollection[]> = null
            var columns = req.columns.map(c => c.id)
            if (!this.loadLatest) {
                switch (this.$scope.filter) {
                    case MeasurementsSelectedFilter.Locations:
                        if (req.locationIds && req.locationIds.length > 0) {
                            dataProviderRequest = this.userSession.getDataProvider().Measurements.getMeasurementsFilter(req.locationIds, null, null, columns, req.dateFrom, req.dateTo)
                        }
                        break;
                    case MeasurementsSelectedFilter.Devices:
                        if (req.deviceIds && req.deviceIds.length > 0) {
                            dataProviderRequest = this.userSession.getDataProvider().Measurements.getMeasurementsFilter(req.locationIds, req.deviceIds, null, columns, req.dateFrom, req.dateTo)
                        }
                        break;
                    case MeasurementsSelectedFilter.Meters:
                        if (req.meterIds && req.meterIds.length > 0) {
                            dataProviderRequest = this.userSession.getDataProvider().Measurements.getMeasurementsFilter(req.locationIds, null, req.meterIds, columns, req.dateFrom, req.dateTo)
                        }
                        break;
                }
            } else {

                switch (this.$scope.filter) {
                    case MeasurementsSelectedFilter.Locations:
                        if (req.locationIds && req.locationIds.length > 0) {
                            dataProviderRequest = this.userSession.getDataProvider().Measurements.getLatestMeasurementsFilter(req.locationIds, null, null, columns)
                        }
                        break;
                    case MeasurementsSelectedFilter.Devices:
                        if (req.deviceIds && req.deviceIds.length > 0) {
                            dataProviderRequest = this.userSession.getDataProvider().Measurements.getLatestMeasurementsFilter(req.locationIds, req.deviceIds, null, columns)
                        }
                        break;
                    case MeasurementsSelectedFilter.Meters:
                        if (req.meterIds && req.meterIds.length > 0) {
                            dataProviderRequest = this.userSession.getDataProvider().Measurements.getLatestMeasurementsFilter(req.locationIds, null, req.meterIds, columns)
                        }
                        break;
                }
            }
            if (dataProviderRequest) {
                dataProviderRequest
                    .then((collection: MeasureCollection[]) => {
                        this.$scope.$root.$broadcast('enableLoadingIndicator')
                        var measures: MeasurementModel[] = []
                        collection.forEach(c => {
                            c.measures.forEach(m => {
                                var measurementModel = new MeasurementModel()
                                measurementModel.dataType = c.idDataType
                                measurementModel.date = m.time
                                measurementModel.idLocation = c.idLocation
                                measurementModel.idMeter = c.idMeter
                                measurementModel.serialNbr = c.serialNbr

                                measurementModel['deviceString'] = c.device != null ? c.device.toString() : null
                                measurementModel['locationString'] = c.location != null ? c.location.toString() : null
                                measurementModel['meterString'] = c.meter != null ? c.meter.toString() : null

                                var isDate = CommonHelper.regexMicrosoftDate.test(m.value)

                                if (isDate) {
                                    measurementModel.value = new Date(moment.parseZone(m.value).format('LLL'))
                                } else {
                                    measurementModel.value = m.value
                                }

                                measurementModel.isDate = isDate
                                const dataType = req.columns.filter(column => column.id == c.idDataType)[0]

                                if (dataType) {
                                    measurementModel['typeId'] = dataType.type
                                }

                                measures.push(measurementModel)
                            })
                        })
                        this.$scope.$root.$broadcast('disableLoadingIndicator')
                        defer.resolve(measures)
                    })
                    .fail((error: DataProviderRequestError) => {
                        const msg: string = ConvertHelper.getRequestErrorMessage(error)

                        ToastHelper.showError(msg)

                        defer.reject(error)
                    })
            }
            else {
                defer.resolve([])
            }

            return defer.promise
        } else {
            if (req.columns.length && (req.locationIds && req.locationIds.length > 0 || req.deviceIds && req.deviceIds.length > 0 || req.meterIds && req.meterIds.length > 0)) {
                var methodName = this.loadLatest ? this.$scope.source.latestDataMethodName : this.$scope.source.dataMethodName
                this.$scope.$root.$broadcast('disableLoadingIndicator')

                return this.api.measurement[methodName](req, this.requestState).then((result: MeasurementModel[]) => {
                    this.$scope.$root.$broadcast('enableLoadingIndicator')

                    result.forEach(row => {
                        this.localDictionary.getDataTypes([row.dataType]).then(dataTypes => {
                            if (dataTypes[0]) {
                                row['typeId'] = dataTypes[0].type
                            }
                        })
                    })

                    return result
                }).catch(e => {
                    return []
                })
            }
            else {
                if (req.columns.length == 0)
                    CommonHelper.openInfoPopup(i18n('Popup', 'PleaseSelectDatatype'), 'info')
                const defer: ng.IDeferred<MeasurementModel[]> = this.$q.defer<MeasurementModel[]>()
                defer.resolve([])
                return defer.promise
            }
        }
    }

    private colorFixingButton(element) {
        this.$timeout(() => {
            var gridConfig = OperatorLayoutSettings.getSetting('SAVED_TABLE_' + this.$scope.gridOptions.name, null)
            if (gridConfig) {
                var currentFixing = gridConfig.columnAutoWidth
                if (currentFixing) {
                    element.addClass("active-button")
                } else {
                    element.removeClass("active-button")
                }
            }
        })
    }

    static getTypesFromColumns(columns: ColumnModel[]) {
        var types: MeasurementDataType[] = []
        columns.forEach((element, index) => {
            types[index] = {
                id: element.id,
                dataTypeId: element.id,
                name: element.caption,
                unitType: element.unitId,
                unitName: element.unitName,
                type: element.type
            }
            types[index]['chartType'] = element.chartType
            if (element.type == CommonHelper.datetime) {
                types[index]['isDate'] = true
            }
        })
        return types
    }

    static getChartData(data: any[], types: any[], idFieldName: string, tooltipNames: any[]) {
        var newTypes = []
        var newData = []
        var existingDataTypes = {}

        if (data) {
            if (tooltipNames && tooltipNames.length > 1) {
                var dataByEntity = {}
                data.forEach(d => {
                    if (!dataByEntity[d[idFieldName]]) dataByEntity[d[idFieldName]] = []
                    dataByEntity[d[idFieldName]].push(d)
                    existingDataTypes[d.dataType + '-' + d[idFieldName]] = true
                })

                types.forEach(type => {
                    for (var index in dataByEntity) {
                        var values: any[] = dataByEntity[index]
                        var tooltipName = tooltipNames.filter(tN => tN.id == index)[0]
                        if (tooltipName) tooltipName = tooltipName.name
                        else tooltipName = index
                        if (existingDataTypes[type.id + '-' + index]) {
                            var newType = {
                                dataTypeId: type.id,
                                id: type.id + '-' + index,
                                name: tooltipName + ': ' + type.name,
                                unitName: type.unitName,
                                unitType: type.unitType,
                                chartType: type.chartType
                            }
                            newTypes.push(newType)
                        }
                    }
                })

                for (var index in dataByEntity) {
                    var values: any[] = dataByEntity[index]
                    values.forEach(value => {
                        var d = angular.copy(value)
                        d.dataTypeId = value.dataType
                        d.dataType = value.dataType + '-' + index
                        newData.push(d)
                    })
                }
            } else {
                newData = data

                data.forEach(d => {
                    existingDataTypes[d.dataType] = true
                })
                types.forEach(type => {
                    if (existingDataTypes[type.id]) {
                        newTypes.push(type)
                    }
                })
            }
        }

        return {
            data: newData,
            types: newTypes
        }
    }

    static exportMeasurements(request: MeasurementsRequestModel, gridColumns: any[], localDictionary: LocalDictionaryFactory, $q: ng.IQService, api: Api) {
        var req = _.clone(request)

        // FIX problems in grid
        gridColumns = gridColumns.map(c => _.clone(c))

        req.gridColumns = []
        var promices = []
        gridColumns.forEach(item => {
            if (item.dataField == 'serialNbrText') {
                item.dataField = DataType.HELPER_SERIAL_NBR
                promices.push(localDictionary.getDataTypes([DataType.HELPER_SERIAL_NBR]))
            } else if (item.dataField == 'idMeterText') {
                item.dataField = DataType.HELPER_ID_METER
                promices.push(localDictionary.getDataTypes([DataType.HELPER_ID_METER]))
            } else if (item.dataField == 'idLocationText') {
                item.dataField = DataType.HELPER_ID_LOCATION
                promices.push(localDictionary.getDataTypes([DataType.HELPER_ID_LOCATION]))
            } else if (item.dataField == 'index') {
                item.dataField = DataType.HELPER_INDEX_NBR
                promices.push(localDictionary.getDataTypes([DataType.HELPER_INDEX_NBR]))
            } else if (item.dataField == 'date') {
                item.dataField = DataType.HELPER_TIME
                promices.push(localDictionary.getDataTypes([DataType.HELPER_TIME]))
            } else if (item.dataField == 'dataTypeName') {
                item.dataField = DataType.HELPER_ID_DATA_TYPE
                promices.push(localDictionary.getDataTypes([DataType.HELPER_ID_DATA_TYPE]))
            } else if (item.dataField == 'valueText') {
                item.dataField = DataType.HELPER_VALUE
                promices.push(localDictionary.getDataTypes([DataType.HELPER_VALUE]))
            } else if (item.dataField == 'unit') {
                item.dataField = DataType.HELPER_ID_UNIT
                promices.push(localDictionary.getDataTypes([DataType.HELPER_ID_UNIT]))
            } else {
                promices.push(localDictionary.getDataTypes([item.dataField]))
            }
        })

        $q.all(promices).then(item => {
            item.slice(0).forEach((column: ColumnModel[]) => {
                if (column.length > 0) {
                    var resouceColumn = gridColumns.filter(item => { return item.dataField == column[0].id })
                    if (resouceColumn.length > 0) {
                        column[0].caption = resouceColumn[0].caption
                        req.gridColumns.push(column[0])
                    }
                }
            })



            var exportMethod = 'measurements'

            api.app.saveMeasurementsRequestModel(req).then(token => {
                if (token) {
                    CommonHelper.setJWTCookie(api.login.getToken())
                    window.open(window['config'].API_URL + 'api/app/' + exportMethod + '/export/' + token, '_self');
                }
                else {
                    CommonHelper.openInfoPopup(i18n('Popup', exportMethod + 'ExportError'), 'error', 5000)
                }
            })
        })
    }

    private getSingleColumnByDataType(moduleName: Enums.SimaxModuleName, dataType: Enums.DataType): ColumnModel[] {
        let singleColumn: ColumnModel[] = []
        this.userSession.getDataProvider().System.getRequestColumnInfo(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__GRID_PARAMS,
            moduleName).then((columns: ColumnModel[]) => {
                columns.forEach((column: ColumnModel) => {
                    if (column.id != null && column.id === dataType) {
                        column.alignment = 'left'
                        singleColumn.push(column)
                    }
                })
            })
        return singleColumn
    }

    private setThresholds(result: any[], dtypesPermission: boolean, types: MeasurementDataType[], savedIds: number[]): void {
        this.thresholdTypes = MeasurementsController.getTypesFromColumns(result).map(t => {
            t.isThresholdType = true
            return t
        })

        let typetags: any[] = []
        this.selectedTypes.forEach((selectedType: MeasurementDataType) => {
            if (!this.thresholdTypes.some(thrType => { return thrType.id == selectedType.id && !savedIds.some(id => thrType.id == id) })) {
                typetags.push(selectedType.name)
            }
        })

        this.addThresholdTypes()

        this.$scope.dataTypesOptionsPermission = dtypesPermission
        if (this.$scope.dataTypesOptionsPermission) {
            this.selectedTypes = types
            typetags = types.map(type => { return type.name })
        }

        this.$scope.selectedDataTypesSource.staticSource = types
        this.$scope.selectedDataTypesSource.selectedIds = savedIds

        this.$scope.isSelectPopoverLoading = false

        this.refreshGridColumns()
    }

    private setDataTypeFilterOptions(data: MeasurementDataType[], dtypesPermission: boolean): void {
        if (!dtypesPermission) {
            if (!data) {
                data = []
            }
            this.$scope.selectedDataTypesSource.selectedIds = []
            if (!this.disableTypesOnChange) {
                this.selectedTypes = data
                this.$scope.selectedDataTypesSource.selectedIds = data.map(d => { return d.id })

                let storageName = ""
                switch (this.$scope.filter) {
                    default:
                    case MeasurementsSelectedFilter.Locations:
                        storageName = "locationDataTypes"
                        break;
                    case MeasurementsSelectedFilter.Devices:
                        storageName = "deviceDataTypes"
                        break;
                    case MeasurementsSelectedFilter.Meters:
                        storageName = "meterDataTypes"
                        break;
                }
                if (this.$scope.isKpi) {
                    storageName = "KPI" + storageName;
                }

                OperatorLayoutSettings.setSetting(storageName, this.selectedTypes.map(type => type.id))

                this.addThresholdTypes()

                if (this.selectedGridType == this.GRID_TYPES.IN_COLUMNS.id) this.updateGridColumnsDataTypeColumns()

                if (this.$scope.chartBridge && this.canRefreshMeasurments(this.selectedTypes)) {
                    this.$scope.chartBridge.data = void 0
                    this.loadMeasurements(true, 1000)
                } else {
                    this.loadMeasurements(false, 1000)
                }
            }
        }
    }
}
